import React from 'react';
import { Helmet } from 'react-helmet-async';

const APP_SUFFIX = 'Business Management System';

/**
 * Sets the browser tab title.
 * pageName: the specific page name (e.g. "Employee List")
 */
export default function DocumentTitle({ pageName }) {
  return (
    <Helmet>
      <title>{`${pageName} — ${APP_SUFFIX}`}</title>
    </Helmet>
  );
}
